import { Link } from "react-router-dom";
import { isExternal } from "@/lib/api";

export const SmartLink = ({ item, className, children, testId, onClick, title }) => {
  if (isExternal(item)) {
    return (
      <a href={item.href} target="_blank" rel="noopener noreferrer" className={className} data-testid={testId} onClick={onClick} title={title}>
        {children}
        <span className="sr-only"> (yeni sekmede açılır)</span>
      </a>
    );
  }
  return (
    <Link to={item.to || item.href} className={className} data-testid={testId} onClick={onClick}>
      {children}
    </Link>
  );
};
